// src/components/ui/forms/PartnerCodeInput/PartnerCodeInput.jsx
import React from 'react';
import { KeyRound } from 'lucide-react';
import { Input } from '../../input';
import { cn } from '../../../../utils/cn';

const PartnerCodeInput = ({
  value,
  onChange,
  placeholder = "ABC-12345",
  maxLength = 9,
  className = '',
  ...props
}) => {
  // Format partner code as XXX-XXXXX
  const formatPartnerCode = (inputValue) => {
    // Remove any non-alphanumeric characters and convert to uppercase
    const cleaned = inputValue.replace(/[^A-Z0-9]/gi, '').toUpperCase();
    
    // Format as XXX-XXXXX
    if (cleaned.length <= 3) {
      return cleaned;
    } else {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 8)}`;
    }
  };

  const handleChange = (e) => {
    const formatted = formatPartnerCode(e.target.value);
    
    // Create a new event object with the formatted value
    const formattedEvent = {
      ...e,
      target: {
        ...e.target,
        value: formatted
      }
    };
    
    onChange(formattedEvent);
  };

  return (
    <div className="relative">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <KeyRound className="w-5 h-5 text-muted-foreground" />
      </div>
      <Input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLength}
        className={cn(
          // Partner code specific styling
          "text-center font-mono text-lg tracking-wider pl-10",
          className
        )}
        {...props}
      />
    </div>
  );
};

export default PartnerCodeInput;